import * as z from 'zod';

export const passwordMethod = (params: z.core.$ZodStringParams = {}) =>
  z
    .string({ error: 'required', ...params })
    .min(6, { message: 'password.min' })
    .max(20, { message: 'password.max' })
    .regex(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/, {
      message: 'password.minSymbols',
    });
